'use client'

import { InspirationalClientLink } from '@fukku/button/ClientLink/Inspirational/InspirationalClientLink'
import { sendGenericEvent } from 'analytics/events/generics/sendGenericEvent'
import { CommonGenericEvents } from 'footer/constants/analytics/analytics'
import { DATATESTID_PREFIX } from 'footer/constants/translations'

import type { NavigationLink } from '../NavigationLinks'
import styles from './NavigationLinkItem.module.css'
import { StoreLocatorButton } from './StoreLocatorButton/StoreLocatorButton'

type NavigationLinkItemProps = {
	readonly item: NavigationLink
}

export function NavigationLinkItem({ item }: NavigationLinkItemProps) {
	const { title, href, dataTestId } = item

	const normalizedDataTestId = dataTestId.replace(DATATESTID_PREFIX, '')

	if (!href) {
		return <StoreLocatorButton />
	}

	const handleLinkClick = () => {
		sendGenericEvent(CommonGenericEvents.LINK_SELECTED, {
			section: normalizedDataTestId,
		})
	}

	return (
		<InspirationalClientLink
			className={styles.navigationLink}
			href={href}
			data-testid={normalizedDataTestId}
			onClick={handleLinkClick}
		>
			{title}
		</InspirationalClientLink>
	)
}
